import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { ENV_COUNTERPARTY_GUID } from 'common/constants/env.constants';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  createCounterpartyService,
  getCounterpartiesListService,
  updateCounterpartyService,
} from '../services/counterparty.service';
import {
  TCounterpartiesListReqParams,
  TCounterpartiesListResData,
  TCounterpartyEntity,
  TCreateCounterpartyReqData,
  TUpdateCounterpartyReqData,
} from '../types/counterparty.types';

// TODO: should be changed on useGetCounterpartiesQuery
export const counterpartyQuery = (
  params?: TCounterpartiesListReqParams
): {
  queryKey: (string | TCounterpartiesListReqParams | string)[],
  queryFn: () => Promise<TCounterpartiesListResData>,
} => ({
  queryKey: ['counterparties', 'list', params ?? 'all'],
  queryFn: (): Promise<TCounterpartiesListResData> => getCounterpartiesListService(params),
});

export const useGetCounterpartiesQuery = (
  params?: TCounterpartiesListReqParams,
  options?: any,
): UseQueryResult<TCounterpartiesListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.CounterpartyQueryKeys].getCounterpartiesList(params),
    ...options,
  });

export const useGetCounterpartiesTableQuery = (
  params?: TCounterpartiesListReqParams,
  options?: any,
): UseQueryResult<{
  originalResponse: TCounterpartiesListResData,
  tableData: any,
}> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.CounterpartyQueryKeys].getCounterpartiesList(params),
    ...options,
  });

export const useGetMainCounterpartyQuery = (): UseQueryResult<TCounterpartyEntity> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.CounterpartyQueryKeys].getMainCounterparty({ guids: [ENV_COUNTERPARTY_GUID] }),
    ...{
      select: (data: TCounterpartiesListResData) => data.counterparties[0],
      staleTime: 1000 * 60 * 60 * 4, // 4 Hours
    },
  });

export const useCreateCounterpartyMutation = (): any =>
  useMutation({
    mutationFn: (data: { requestData: TCreateCounterpartyReqData }) => createCounterpartyService(data.requestData),
  });

export const useUpdateCounterpartyMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TUpdateCounterpartyReqData }) =>
      updateCounterpartyService(data.counterpartyGUID, data.requestData),
  });
